export type PwaPlatform = 'ios' | 'android' | 'desktop' | 'unknown';

export function isStandaloneDisplay(): boolean {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.matchMedia('(display-mode: fullscreen)').matches ||
    (navigator as Navigator & { standalone?: boolean }).standalone === true
  );
}

export function detectPwaPlatform(): PwaPlatform {
  const ua = navigator.userAgent;
  const isIOS =
    /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  if (isIOS) return 'ios';
  if (/Android/i.test(ua)) return 'android';
  if (/Windows|Macintosh|Linux|CrOS/.test(ua)) return 'desktop';
  return 'unknown';
}

/** Chrome / Edge incognito suele tener cuota de almacenamiento muy baja. */
export async function detectLikelyIncognito(): Promise<boolean> {
  try {
    if ('storage' in navigator && 'estimate' in navigator.storage) {
      const { quota } = await navigator.storage.estimate();
      if (typeof quota === 'number' && quota > 0 && quota < 120_000_000) return true;
    }
  } catch {
    /* */
  }
  try {
    const db = indexedDB.open('__pwa_incognito_probe__');
    await new Promise<void>((resolve, reject) => {
      db.onerror = () => reject(db.error);
      db.onsuccess = () => {
        db.result.close();
        indexedDB.deleteDatabase('__pwa_incognito_probe__');
        resolve();
      };
    });
  } catch {
    return true;
  }
  return false;
}

export const PWA_INSTALL_DISMISS_KEY = 'va_pwa_install_dismiss_session';

export function readInstallDismissed(): boolean {
  try {
    return sessionStorage.getItem(PWA_INSTALL_DISMISS_KEY) === '1';
  } catch {
    return false;
  }
}

export function writeInstallDismissed(): void {
  try {
    sessionStorage.setItem(PWA_INSTALL_DISMISS_KEY, '1');
  } catch {
    /* */
  }
}

export const PWA_ORIGIN =
  (import.meta.env.VITE_PWA_PUBLIC_URL as string | undefined)?.trim() ||
  'https://pwa.interactivetalker.com';
